import React, { useState, useEffect } from 'react';
import './AgeVerification.css';

const AgeVerification = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has already verified age
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShow(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShow(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!show) return null;

  return (
    <div className="age-verification-overlay">
      <div className="age-verification-modal">
        <div className="age-verification-icon" aria-hidden="true">18+</div>
        <h1>Age Verification Required</h1>
        <p className="age-verification-text">
          This website contains adult content and is intended for adults only.
        </p>
        <p className="age-verification-question">
          Are you 18 years of age or older?
        </p>
        <div className="age-verification-buttons">
          <button className="btn-confirm" onClick={handleConfirm}>
            Yes, I am 18+
          </button>
          <button className="btn-decline" onClick={handleDecline}>
            No, I am under 18
          </button>
        </div>
        <p className="age-verification-disclaimer">
          By entering this site, you agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;
